import { SearchParams } from "../entry/local/movie";
import { DownloadOption, Movie, MovieCommentData, MovieDetails, PlayerData, ReportData, SearchFilters, SearchResult, TaxonomyInfo } from "../entry/server/movie";
import { api, ApiResponse } from "../lib/api";

export const videoService = {
    getDetails: async (id: number): Promise<ApiResponse<MovieDetails>> => {
        return await api.get<MovieDetails>({ url: `movie/${id}` });
    },
    getDownloadOptions: async (id: number): Promise<ApiResponse<DownloadOption[]>> => {
        return await api.get<DownloadOption[]>({ url: `movie/${id}/download-options` });
    },
    getRelatedMovies: async (id: number): Promise<ApiResponse<Movie[]>> => {
        return await api.get<Movie[]>({ url: `movie/${id}/related-movies` });
    },
    likeMovie: async (id: number, action: 'like' | 'dislike'): Promise<ApiResponse<any>> => {
        return await api.post<any>({ url: `movie/${id}/${action}` });
    },
    getSearchFilters: async (): Promise<ApiResponse<SearchFilters>> => {
        return await api.get<SearchFilters>({ url: `search-filters`, revalidate: 60 * 60 * 24 });
    },
    search: async (searchParams: SearchParams, cancelSignal?: AbortSignal): Promise<ApiResponse<SearchResult>> => {
        let queryParams: Record<string, string> = {};
        if (searchParams.s) {
            queryParams.s = searchParams.s;
        }
        if (searchParams.type) {
            queryParams.type = searchParams.type as string;
        }
        if (searchParams.imdb_rate) {
            queryParams.imdb_rate = searchParams.imdb_rate.toString();
        }
        if (searchParams.age_rating) {
            queryParams.age_rating = searchParams.age_rating as string;
        }
        if (searchParams.is_dubbed) {
            queryParams.is_dubbed = searchParams.is_dubbed.toString();
        }
        if (searchParams.is_subbed) {
            queryParams.is_subbed = searchParams.is_subbed.toString();
        }
        if (searchParams.start_year) {
            queryParams.start_year = searchParams.start_year.toString();
        }
        if (searchParams.end_year) {
            queryParams.end_year = searchParams.end_year.toString();
        }
        if (searchParams.status) {
            queryParams.status = searchParams.status;
        }
        if (searchParams.genre) {
            queryParams.genre = searchParams.genre.toString();
        }
        if (searchParams.country) {
            queryParams.country = searchParams.country.toString();
        }
        if (searchParams.language) {
            queryParams.language = searchParams.language.toString();
        }
        if (searchParams.network) {
            queryParams.network = searchParams.network.toString();
        }
        if (searchParams.director) {
            queryParams.director = searchParams.director;
        }
        if (searchParams.actor) {
            queryParams.actor = searchParams.actor;
        }
        if (searchParams.sort) {
            queryParams.sort = searchParams.sort;
        }
        if (searchParams.page) {
            queryParams.page = searchParams.page.toString();
        }
        if (searchParams.limit) {
            queryParams.limit = searchParams.limit.toString();
        }
        return await api.get<SearchResult>({ url: `search`, queryParams, signal: cancelSignal });
    },
    getTaxonomyInfo: async (type: 'genre' | 'country' | 'network' | 'language' | 'release', slug: string): Promise<ApiResponse<TaxonomyInfo>> => {
        return await api.get<TaxonomyInfo>({ url: `taxonomy/${type}/${slug}`, revalidate: 60 * 60 * 24 * 7 });
    },
    addComment: async (movieId: number, comment: string, parentId?: number, isSpoiler?: boolean, isReview?: boolean, score?: number): Promise<ApiResponse<any>> => {
        return await api.post<any>({ url: "comments/" + movieId, body: { comment: comment, parent_id: parentId, is_spoiler: isSpoiler, is_review: isReview, score: score } });
    },
    getComments: async (movieId: number, isReview: 'true' | 'false', page: number): Promise<ApiResponse<MovieCommentData[]>> => {
        return await api.get<MovieCommentData[]>({ url: `comments/${movieId}`, queryParams: { page: page.toString(), is_review: isReview } });
    },
    likeComment: async (commentId: number, action: 'like' | 'dislike'): Promise<ApiResponse<any>> => {
        return await api.post<any>({ url: `comments/${commentId}/${action}` });
    },
    updateFavoriteStatus: async (movieId: number): Promise<ApiResponse<any>> => {
        return await api.post<any>({ url: `movie/${movieId}/favorite` });
    },
    addReport: async (movieId: number, title: string, reason: string): Promise<ApiResponse<any>> => {
        return await api.post<any>({ url: `reports`, body: { movie_id: movieId, title, reason } });
    },
    getReports: async (page: number): Promise<ApiResponse<ReportData[]>> => {
        return await api.get<ReportData[]>({ url: `reports`, queryParams: { page: page.toString() } });
    },
    getPlayerData: async (id: number, season: number, episode: number): Promise<ApiResponse<PlayerData>> => {
        return await api.get<PlayerData>({ url: `player/${id}/${season}/${episode}` });
    },
};